package fr.labodoc.healthProfessional.api.payloads.requests

import kotlinx.serialization.Serializable

@Serializable
data class UpdateSelfMedicalInterestsRequest(
  val medicalInterestIds: List<String>
)
